import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent {
  @Input() data: any = {
    UserDetails: {}, // Logged-in user details
    links: 'https://services.apnasite.in/iam-citizen-components/images/bannerImage.jpg',
  };

  ngOnInit(){
    try {
      this.data = typeof this.data === 'string' ? JSON.parse(this.data) : this.data;
    } catch (error) {
      console.error("Error parsing input data/config:", error);
    }
    console.log("banner: ", this.data);
  }
}
